import { AccountViewer } from "components/form/graphql/types";

export const canDeleteRole = (viewer: AccountViewer | undefined): boolean => !!viewer?.admin;
